<template>
<!-- 费用计算 -->
<div>
  <div class="addressBox">
    <h4 class="title">
      <span><i class="fa fa-calculator iconFont" aria-hidden="true"></i>费用相关</span>
    </h4>
    <div>
      <el-form-item label="计价方式 :" prop="pricingMethod" class="jiage">
        <el-select  v-model="goodform.pricingMethod"  placeholder="请选择" @change="pricingMethodChange" >
          <el-option v-for="val in jjfangshi" :label="val.name" :value="val.val" :key="val.val"></el-option>
          <!-- <el-option label="区域二" value="beijing"></el-option> -->
        </el-select>
      </el-form-item>
      <el-form-item label="不含税单价:" class="jiage" prop="unitPrice" v-if="goodform.pricingMethod==''||goodform.pricingMethod==2?false:true">
        <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.unitPrice"  ></el-input><span class="danwei">元/{{goodform.unitMeasurement}}</span>
      </el-form-item>
      <el-form-item label="包干价:" class="jiage" prop="unitPrice" v-if="goodform.pricingMethod==''||goodform.pricingMethod==1?false:true">
        <el-input  placeholder=""  v-number-input.float="2"  maxlength="8" v-model="goodform.unitPrice" ></el-input><span class="danwei">元</span>
      </el-form-item>
      <el-form-item label="服务费:" class="jiage" prop="taxation">
        <span>{{goodform.taxation|numFormat(2)}}</span>元
      </el-form-item>
      <el-form-item label="服务费率:"  prop="rate">
        <span class="danwei">{{goodform.rate*100}}%</span>
      </el-form-item>
      <el-form-item label="" class="mar10">
        合计费用:<span class="red">{{goodform.allP|numFormat(2)}}</span>元
      </el-form-item>
      <el-form-item label="" class="mar10">
        <span class="red">（注：服务费 = 司机运费 /（1-服务费率）* 服务费率&nbsp;&nbsp;&nbsp;&nbsp;合计费用 = 司机运费+服务费）</span>
      </el-form-item>
      <div v-if="isPayCustomer[0]">
        <el-form-item label="付款客户 :" prop="payCustomerName">
          <el-select  v-model="goodform.payCustomerName" filterable placeholder="请选择">
            <el-option v-for="item in customTypes" :label="item.value1" :value="item.value1" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款金额 :" prop="payCustomerReceiveAmount">
         <el-input placeholder="请输入收款金额" maxlength="8" v-number-input.float="2" v-model="goodform.payCustomerReceiveAmount" ></el-input>
        </el-form-item>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { findSMPRate, dictionaryList } from '@/api/soc-customer'
import { toFixed } from '@/utils/util'
import { getAttribute } from '@/utils/getButton'
export default {
  name: 'changeCar',
  props: {
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      toFixed: toFixed,
      jjfangshi: [
        { val: 1, name: '单价' },
        { val: 2, name: '包干' }
      ],
      customTypes: [],
      isPayCustomer: null
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (!this.goodform.rate) {
      const loading = this.$loading({
        lock: true,
        text: '正在加载...'
      })
      let that = this
      findSMPRate().then(res => {
        loading.close()
        this.$set(this.goodform, 'rate', res.taxRate)
      // eslint-disable-next-line handle-callback-err
      }).catch(error => {
        findSMPRate().then(res => {
          this.$set(this.goodform, 'rate', res.taxRate)
        // eslint-disable-next-line handle-callback-err
        }).catch(error => {
          findSMPRate().then(res => {
            this.$set(this.goodform, 'rate', res.taxRate)
          // eslint-disable-next-line handle-callback-err
          }).catch(error => {
            this.$message({
              showClose: true,
              message: '该功能暂不可用，请稍后再试',
              type: 'error',
              onClose () {
                loading.close()
                that.$router.push({ name: 'orderManage' })
              }
            })
          })
        })
      })
    }
  },
  created () {
    this.dictionaryList()
    this.isPayCustomer = getAttribute('ARRisPayCustomer', 1)
  },
  methods: {
    pricingMethodChange () {
      this.$emit('costChange', this.goodform)
    },
    dictionaryList () {
      dictionaryList({
        groupName: 'pay_customs'
      }).then(res => {
        this.customTypes = res
      })
    }
  },
  watch: {
    goodform: {
      handler (newName, oldName) {
        // this.$set(this.goodform, 'weight', newName.weight)
        // this.$set(this.goodform, 'unitMeasurement', newName.unitMeasurement)
        // 旧版
        // 包干 运费=单价  服务费=运费*服务费率  合计=运费+服务费
        //  单价  运费=单价*重量  服务费率后端接口取   服务费=运费*服务费率   合计=运费+服务费
        // 新版  2023.02.03改
        // 包干  运费=单价  服务费 = 运费 /（1-服务费率）* 服务费率  合计 = 运费 /（1-服务费率）
        // 单价  运费=单价*重量  服务费 = 运费/（1-服务费率）* 服务费率  合计 = 运费 /（1-服务费率）
        if (this.goodform.pricingMethod == 1) { // 单价
          if (this.goodform.weight && this.goodform.unitPrice) {
            this.goodform.fatePrice = this.toFixed(accMul(this.goodform.weight, this.goodform.unitPrice), 2) // 运费
            // console.log(this.goodform.fatePrice, 'this.goodform.fatePrice')
            // this.goodform.taxation = accMul(this.goodform.rate, Number(this.toFixed(this.goodform.fatePrice, 2))) //服务费
            this.goodform.taxation = this.goodform.fatePrice / (1 - this.goodform.rate) * this.goodform.rate
            // this.$set(this.goodform, 'allP', Number(this.toFixed(this.goodform.fatePrice, 2)) + Number(this.toFixed(this.goodform.taxation, 2)))
            this.$set(this.goodform, 'allP', this.toFixed(Number(this.goodform.fatePrice) / Number((1 - this.goodform.rate)), 2))
            // console.log(this.goodform.allP, '单价')
          } else {
            this.$set(this.goodform, 'fatePrice', 0)
          }
        } else if (this.goodform.pricingMethod == 2) { // 包干
          if (this.goodform.unitPrice) {
            this.goodform.fatePrice = this.goodform.unitPrice
            // this.goodform.taxation = this.toFixed(accMul(this.goodform.rate, this.goodform.fatePrice), 2)
            this.goodform.taxation = this.goodform.fatePrice / (1 - this.goodform.rate) * this.goodform.rate
            // this.$set(this.goodform, 'allP', Number(this.toFixed(this.goodform.fatePrice, 2)) + Number(this.toFixed(this.goodform.taxation, 2)))
            this.$set(this.goodform, 'allP', this.toFixed(Number(this.goodform.fatePrice) / Number((1 - this.goodform.rate)), 2))
            // console.log(this.goodform.allP, '包干')
          }
        }

        function accMul (arg1, arg2) {
          var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
          try {
            m += s1.split('.')[1].length
          } catch (e) {
          }
          try {
            m += s2.split('.')[1].length
          } catch (e) {
          }

          return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
        }
      },
      deep: true
      // immediate: true
    }
  },
  destroyed () {
  }
}
</script>

<style scoped lang='less'>

</style>
